import { connect } from 'react-redux';
import { FormSpy } from 'react-final-form';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { DecisionOrganization } from 'DecisionPackage/DecisionSubjectModule/components/DecisionOrganization';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import {
  INSPECTORS_BLOCK_ID,
  PROSECUTOR_ORGANIZATION_BLOCK_ID,
  getInspectorBlockId,
} from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { IDictionaryParticipantPositionSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryParticipantPositionSelectOption';
import { IDictionaryPositionSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryPositionSelectOption';
import { IDecisionOrganizationForm } from 'DecisionPackage/MainModule/interfaces/IDecisionOrganizationForm';
import { getUserRoleIsSupervisor } from 'AuthPackage/MainModule/selectors/authSelectors';
import { IDecisionFormReason } from 'DecisionPackage/MainModule/interfaces/IDecisionFormReason';

import {
  getDecisionFormRef,
  getDecisionIsCommonWatchOnly,
  getDecisionIsNew,
  getDecisionIsPrescriptionOldRules,
  getDecisionParticipantPositionsSelectOptions,
  getKnmIsDecisionStatusFillInProcess,
} from '../../MainModule/selectors/decisionSelectors';
import { DecisionObjects } from './DecisionObjects';
import { DecisionInspectors } from './DecisionInspectors';

interface IIDecisionSubjectProps {
  created?: string;
  isOrganizationNew: boolean | undefined;
  organization: IDecisionOrganizationForm | undefined;
  reasons: IDecisionFormReason[] | undefined;
}

interface IDecisionSubjectStoreProps {
  formRef: IDecisionFormRef | undefined;
  isDecisionStatusFillInProcess: boolean;
  isNewDecision: boolean;
  isPassportByCheckPrescriptionOldRules: boolean | undefined;
  isSupervisor: boolean;
  isWatchOnly: boolean;
  positionsSelectOptions: IDictionaryPositionSelectOption[] | IDictionaryParticipantPositionSelectOption[] | undefined;
}

const DecisionSubjectWithoutStore = ({
  created,
  isOrganizationNew,
  organization,
  reasons,
  formRef,
  isDecisionStatusFillInProcess,
  isNewDecision,
  isPassportByCheckPrescriptionOldRules,
  isSupervisor,
  isWatchOnly,
  positionsSelectOptions,
}: IIDecisionSubjectProps & IDecisionSubjectStoreProps) => {
  const isDisableSubject = !isSupervisor || (!isNewDecision && !isDecisionStatusFillInProcess);

  return (
    <FieldBlock margin="top">
      <DecisionObjects
        isWatchOnly={isWatchOnly || isDisableSubject}
        created={created}
        organization={organization}
        reasons={reasons}
        isPassportByCheckPrescriptionOldRules={isPassportByCheckPrescriptionOldRules === true}
      />
      <DecisionOrganization
        formRef={formRef}
        organization={organization}
        isNew={isOrganizationNew}
        isWatchOnly={isWatchOnly}
        isPassportByCheckPrescriptionOldRules={isPassportByCheckPrescriptionOldRules === true}
      />
      <Row>
        <FieldBlock label="Наименование прокуратуры" id={PROSECUTOR_ORGANIZATION_BLOCK_ID}>
          <SelectInputField
            id="prosecutorOrganization"
            name="prosecutorOrganization"
            isClearable
            isSearchable
            disabled={true}
            size="medium"
          />
        </FieldBlock>
      </Row>
      <DecisionInspectors
        watchOnly={isWatchOnly || isDisableSubject}
        name="inspectors"
        titleMainPart={<>Сведения о должностных лицах, участвующих в </>}
        titleRestPart="КНМ, СР"
        positionsSelectOptions={positionsSelectOptions}
        blockId={INSPECTORS_BLOCK_ID}
        isDisableDelete={isWatchOnly || isDisableSubject}
        getItemBlockId={getInspectorBlockId}
      />
      <FormSpy subscription={{ errors: true, touched: true }}>
        {props => {
          if (
            props?.touched?.inspectors &&
            props?.errors?.inspectors &&
            typeof props.errors?.inspectors?.[0] === 'string'
          ) {
            const fieldError = props.errors?.inspectors;
            const errorMessage: string | undefined = fieldError
              ? (Object.values(fieldError).reduce((prev: string, curr: string) => prev + curr, '') as string)
              : undefined;

            if (errorMessage) {
              return <p className="shared-input-error">{errorMessage}</p>;
            }
          }

          return null;
        }}
      </FormSpy>
    </FieldBlock>
  );
};

const mapStateToProps = (state: IRootState): IDecisionSubjectStoreProps => ({
  formRef: getDecisionFormRef(state),
  isDecisionStatusFillInProcess: getKnmIsDecisionStatusFillInProcess(state),
  isNewDecision: getDecisionIsNew(state) || false,
  isPassportByCheckPrescriptionOldRules: getDecisionIsPrescriptionOldRules(state),
  isSupervisor: getUserRoleIsSupervisor(state),
  isWatchOnly: getDecisionIsCommonWatchOnly(state),
  positionsSelectOptions: getDecisionParticipantPositionsSelectOptions(state),
});

export const DecisionSubject = connect(mapStateToProps)(DecisionSubjectWithoutStore);
